/* eslint-disable */
import seedrandom from 'seedrandom';
import Node from '../node.js';
import { PARAM_TYPE, PARAM_UNITS } from '../connector.js';
import Utils from '../utils.js';
import Utils3D from '../../utils/utils3D.js';
import CoreUtils from '../../../utils/coreUtils.js';
import Spline from '../spline.js';
import GeoUtils from '../geoUtils.js';
import VoxelGrid from '../voxelGrid.js';
import MeshInfo from '../meshInfo.js';

const EPSILON = 1e-4;

const DEBUG_VERBOSE_OUTPUT = false;
const DEBUG_SKIP_BUILDING_CSG = false;
const DEBUG_VISUALIZE_CUTTING_MESHES = false;
const DEBUG_VISUALIZE_PER_FACE_COLORS = false;
const DEBUG_CREATE_FACE_MARKERS = false;
const DEBUG_DISABLE_TILE_CUTTING = false;
let DEBUG_TRACE_PICKING = false;

//const MAX_TILES = 1;
const MAX_TILES = 50000;

const ADJACENT_FACE_EPSILON = 0.005;

// const CSG_LIB = CSG3D;
const CSG_LIB = BABYLON;

// TODO: Clean up
const fCreaseAngleForCutting = 20.0;
const fCreaseAngleCos = Math.cos(fCreaseAngleForCutting/180.0*Math.PI);

class FaceTraversalInfo
{
	constructor()
	{
		this.facePosition = null;
		this.faceIndex = -1;
		this.normal = null;
		this.sideDir = null;
		this.globalVerts = null;
		this.adjacentFaces = null;
	}

	clone()
	{
		let pCopy = new FaceTraversalInfo();

		pCopy.facePosition = this.facePosition ? this.facePosition.clone() : null;
		pCopy.faceIndex = this.faceIndex;
		pCopy.normal = this.normal ? this.normal.clone() : null;
		pCopy.sideDir = this.sideDir ? this.sideDir.clone() : null;
		pCopy.globalVerts = this.globalVerts ? this.globalVerts.map((vecPoint) => { return vecPoint.clone(); }) : null;
		pCopy.adjacentFaces = this.adjacentFaces ? this.adjacentFaces.slice() : null;

		return pCopy;
	}
}

export default class NodeDistributeOnSurface extends Node
{
	constructor(pParent)
	{
		super(pParent);

		this.addInput(PARAM_TYPE.GEOMETRY, 'object', null);
		this.addInput(PARAM_TYPE.GEOMETRY, 'target', null);

		this.addInput(PARAM_TYPE.BOOLEAN, 'sample_surface', true);
		this.addInput(PARAM_TYPE.BOOLEAN, 'use_instances', false);
		this.addInput(PARAM_TYPE.BOOLEAN, 'jump_holes', true);
		this.addInput(PARAM_TYPE.BOOLEAN, 'enable_edge_cutting', false);	

		this.addInput(PARAM_TYPE.FLOAT, 'hor_spacing', 0.5, { minValue: -1, maxValue: 1, units: PARAM_UNITS.METERS });
		this.addInput(PARAM_TYPE.FLOAT, 'vert_spacing', 0.5, { minValue: -1, maxValue: 1, units: PARAM_UNITS.METERS });
		this.addInput(PARAM_TYPE.FLOAT, 'perp_offset', 0.0, { minValue: -1, maxValue: 1, units: PARAM_UNITS.METERS });

		this.addInput(PARAM_TYPE.BOOLEAN, 'start_from_each_face_boundary', false);
		this.addInput(PARAM_TYPE.FLOAT, 'face_boundary_crease_angle', 70.0, { minValue: 0, maxValue: 180, units: PARAM_UNITS.DEGREES });

		this.addInputsToGroup('Surface Spacing', ['sample_surface', 'use_instances', 'jump_holes', 'enable_edge_cutting', 'hor_spacing', 'vert_spacing', 'perp_offset', 'start_from_each_face_boundary', 'face_boundary_crease_angle']);

		this.addInput(PARAM_TYPE.BOOLEAN, 'simple_surface_mode', false);
		this.addInput(PARAM_TYPE.FLOAT, 'normal_x', 0.0, { minValue: -1, maxValue: 1 });
		this.addInput(PARAM_TYPE.FLOAT, 'normal_y', 1.0, { minValue: -1, maxValue: 1 });
		this.addInput(PARAM_TYPE.FLOAT, 'normal_z', 0.0, { minValue: -1, maxValue: 1 });
		this.addInput(PARAM_TYPE.FLOAT, 'normal_range_angle', 50.0, { minValue: 0, maxValue: 180, units: PARAM_UNITS.DEGREES });
		this.addInputsToGroup('Simple Surface Mode', ['simple_surface_mode', 'normal_x', 'normal_y', 'normal_z', 'normal_range_angle']);

		this.addInput(PARAM_TYPE.BOOLEAN, 'randomly_pick_tile_object', false);
		this.addInput(PARAM_TYPE.STRING, 'probabilities', '0.5,0.5');
		this.addInput(PARAM_TYPE.STRING, 'random_seed', Math.floor(Math.random()*1000));

		this.addInput(PARAM_TYPE.BOOLEAN, 'jitter_hor', false);
		this.addInput(PARAM_TYPE.FLOAT, 'jitter_hor_amount', 0.1, { minValue: 0, maxValue: 1, units: PARAM_UNITS.METERS });

		this.addInput(PARAM_TYPE.BOOLEAN, 'jitter_vert', false);
		this.addInput(PARAM_TYPE.FLOAT, 'jitter_vert_amount', 0.1, { minValue: 0, maxValue: 1, units: PARAM_UNITS.METERS });

		this.addInput(PARAM_TYPE.BOOLEAN, 'jitter_perp', false);
		this.addInput(PARAM_TYPE.FLOAT, 'jitter_perp_amount', 0.05, { minValue: 0, maxValue: 1, units: PARAM_UNITS.METERS });

		this.addInputsToGroup('Surface Randomization', ['randomly_pick_tile_object', 'probabilities', 'random_seed', 'jitter_hor', 'jitter_hor_amount', 'jitter_vert', 'jitter_vert_amount', 'jitter_perp', 'jitter_perp_amount']);
		
		//this.addInput(PARAM_TYPE.BOOLEAN, 'sample_edges', false);
		//this.addInput(PARAM_TYPE.GEOMETRY, 'edge_object', null);
		//this.addInput(PARAM_TYPE.FLOAT, 'edge_crease_angle', 70.0, { minValue: 0, maxValue: 180, units: PARAM_UNITS.DEGREES });

		//this.addInputsToGroup('Edges', ['sample_edges', 'edge_crease_angle']);

				this.addOutput(PARAM_TYPE.GEOMETRY, 'geo');
	}

	getType()
	{
		return 'distributeOnSurface';
	}

	buildNextPolygonInfo(testRay, inputValues, traversedFacesSet, meshInfoObj, currFaceInfo, fXStep, vecOrigUpAxis, fBreakAngle, hitFaceAdjacentInfo, fFinalIntersectDist, bIsHoleJump = false)
	{
		let fCutOffAngleCos = Math.cos(fBreakAngle/180.0*Math.PI);
		let vecIntersectPoint = BABYLON.Vector3.Zero();

		let resInfo = new FaceTraversalInfo();
		resInfo.faceIndex = hitFaceAdjacentInfo.index;
		resInfo.normal = hitFaceAdjacentInfo.normal.clone();
		resInfo.globalVerts = hitFaceAdjacentInfo.globalVerts;
				
		testRay.origin.addToRef(testRay.direction.scale(fFinalIntersectDist), vecIntersectPoint);

		let fDistIntoNewTri = fXStep - fFinalIntersectDist;
		if(bIsHoleJump || (fBreakAngle > 0 && Math.abs(BABYLON.Vector3.Dot(currFaceInfo.normal, resInfo.normal)) < fCutOffAngleCos))
			fDistIntoNewTri = fXStep/2.0;

		resInfo.sideDir = Utils3D.computeNextDirectionAlongSurface(currFaceInfo.sideDir, currFaceInfo.normal, resInfo.normal, vecOrigUpAxis);
		resInfo.facePosition = vecIntersectPoint.add(resInfo.sideDir.scale(1e-5));
		resInfo.adjacentFaces = hitFaceAdjacentInfo.adjacentFaces;

		let secondTriTestInfo = this.pickNextPolygon(inputValues, traversedFacesSet, meshInfoObj, resInfo, fDistIntoNewTri, vecOrigUpAxis, fBreakAngle, fDistIntoNewTri);
		traversedFacesSet.add(resInfo.faceIndex);
		if(secondTriTestInfo)
		{
			resInfo = secondTriTestInfo;
			traversedFacesSet.add(resInfo.faceIndex);
		}
		else
		{
			resInfo.facePosition = vecIntersectPoint.add(resInfo.sideDir.scale(fDistIntoNewTri));

			// We may be ending on a skinny polygon that is the last one - in which case our pick info would still be returning an invalid value
			if(!Utils3D.isPointInTriangle(resInfo.facePosition, resInfo.globalVerts))
				resInfo = secondTriTestInfo;
		}

		return resInfo;
	}

	pickNextPolygon(inputValues, traversedFacesSet, meshInfoObj, currFaceInfo, fXStep, vecOrigUpAxis, fBreakAngle = 0, fMaxRayDist = -1)
	{
		const bJumpHoles = inputValues['jump_holes'];
		// This is the angle of the "corner" on each side; generally, it's pretty
		// strict, but we also need to allow jumping holes with a more lenient angle
		// for cases where the objects are cut at a more shallow angle.
		const fHoleSideAngleCos = Math.cos(80/180.0*Math.PI);
		const fIdenticalNormalsHoleSideAngleCos = Math.cos(30/180.0*Math.PI);

		let resInfo = null;

		let globalVerts = currFaceInfo.globalVerts;
		let faceIndex = currFaceInfo.faceIndex;
		let currNormal = currFaceInfo.normal;
		let vecTestPoint = currFaceInfo.facePosition;
		let finalFaceInfo = currFaceInfo;

		if(!Utils3D.isPointInTriangle(currFaceInfo.facePosition, currFaceInfo.globalVerts))
		{
			if(DEBUG_VERBOSE_OUTPUT)
				CoreUtils.log(`Position outside of the current face detected!`);
			let betterFaceInfo = meshInfoObj.getMeshFaceClosestTo(currFaceInfo.facePosition);
			if(betterFaceInfo.info)
			{
				finalFaceInfo = betterFaceInfo.info;

				// We found a face where this position really belongs to:
				globalVerts = betterFaceInfo.info.globalVerts;
				faceIndex = betterFaceInfo.info.index;
				currNormal = betterFaceInfo.info.normal;
				vecTestPoint = betterFaceInfo.projectedPoint;

				if(DEBUG_VERBOSE_OUTPUT)
					CoreUtils.log(`Found a better face, using that.`);
			}
		}

		let testRay = new BABYLON.Ray(vecTestPoint, currFaceInfo.sideDir);
		if(DEBUG_TRACE_PICKING)
		{
			if(!this.rayCount)
				this.rayCount = 0;
			this.rayCount++;
			let dbRay = new BABYLON.Ray(currFaceInfo.facePosition, currFaceInfo.sideDir, 0.01);
			let pHelper = BABYLON.RayHelper.CreateAndShow(dbRay, BABYLON.Engine.LastCreatedScene, BABYLON.Color3.Random());
			pHelper._renderLine.name = `ray_${this.rayCount}`;
		}

		let fMaxAllowedDistance = fXStep;
		if(fMaxRayDist >= 0 && fMaxRayDist < fMaxAllowedDistance)
			fMaxAllowedDistance = fMaxRayDist;

		let fSelfIntersectDist = -1;
		let iSelfIntersectedSide;
		for(iSelfIntersectedSide = 0; iSelfIntersectedSide < 3; iSelfIntersectedSide++)
		{
			let fIntersectDist = testRay.intersectionSegment(globalVerts[iSelfIntersectedSide], globalVerts[(iSelfIntersectedSide + 1) % 3], EPSILON);
			if(fIntersectDist >= 0 && fIntersectDist <= fMaxAllowedDistance)
			{
				fSelfIntersectDist = fIntersectDist;
				break;
			}
		}

		let finalTraversedSet = traversedFacesSet;
		if(fMaxRayDist >= 0)
		{
			finalTraversedSet = new Set(traversedFacesSet);
			finalTraversedSet.add(faceIndex);
		}

		let selfIntersectPoint = null;
		let selfAdjacentFaceInfo = null;
		if(fSelfIntersectDist >= 0)
		{
			selfIntersectPoint = testRay.origin.add(testRay.direction.scale(fSelfIntersectDist));
			selfAdjacentFaceInfo = meshInfoObj.getAdjacentFace(finalFaceInfo, iSelfIntersectedSide, finalTraversedSet);
		}

		// First, see if we have a hole to jump - prioritize that:
		if(bJumpHoles && selfAdjacentFaceInfo)
		{
			let faceVoxelGrid = meshInfoObj.getFaceVoxelGrid();
			let vecGridSize = faceVoxelGrid.getSize();
			let fMaxSize = Math.max(vecGridSize.x, vecGridSize.y, vecGridSize.z);
			let vecEndPoint = testRay.origin.add(testRay.direction.scale(fMaxSize*2));

			let meshInfo = faceVoxelGrid.getObjectsForSegment(testRay.origin, vecEndPoint);

			for(let meshFace of meshInfo)
			{
				if(faceIndex === meshFace.index)
					continue;

				for(let subIndex = 0; subIndex < 3; subIndex++)
				{
					let fIntersectDist = testRay.intersectionSegment(meshFace.globalVerts[subIndex], meshFace.globalVerts[(subIndex + 1) % 3], EPSILON);
					if(fIntersectDist < 0)
						continue;

					// See if we've hit a polygon that is across a hole.
					let bIsHoleJump = false;

					// Conditions to satisfy are:
					// - No other triangles span the space between start and end, except for this and the target triangle.
					// - This edge and the others either have no adjacent edges (non-volumetric hole) or their adjacent edges are at
					//   a sharp angle to each other.

					let nextHitFaceAdjacentInfo = meshInfoObj.getAdjacentFace(meshFace, subIndex, traversedFacesSet);
					let vecHoleSegmentStart = selfIntersectPoint;
					let vecHoleSegmentEnd;

					// What if we pick the other face initially? Choose the mesh info that is the closest in terms of normals
					let excludedSet = [faceIndex, meshFace.index];
					if(vecHoleSegmentStart)
					{
						if(!selfAdjacentFaceInfo && !nextHitFaceAdjacentInfo)
						{
							// TEMP: Fix and re-enable. If re-enabling, make sure we uncomment the null clause for self-intersect above.
							////bIsHoleJump = true;
						}
						else if(selfAdjacentFaceInfo && nextHitFaceAdjacentInfo)
						{
							// Check their normals:
							let fNextSideDot = BABYLON.Vector3.Dot(nextHitFaceAdjacentInfo.normal, meshFace.normal);
							let fThisSideDot = BABYLON.Vector3.Dot(selfAdjacentFaceInfo.normal, currNormal);
							if(fThisSideDot <= fHoleSideAngleCos && fNextSideDot <= fHoleSideAngleCos)
								bIsHoleJump = true;
							
							if(Math.abs(fNextSideDot - fThisSideDot) < EPSILON && fThisSideDot <= fIdenticalNormalsHoleSideAngleCos && fNextSideDot <= fIdenticalNormalsHoleSideAngleCos)
								bIsHoleJump = true;

							excludedSet.push(selfAdjacentFaceInfo.index);
							excludedSet.push(nextHitFaceAdjacentInfo.index);
						}
					}

					if(bIsHoleJump)
					{
						// Test that no actual other faces contain the line between
						vecHoleSegmentEnd = testRay.origin.add(testRay.direction.scale(fIntersectDist));
						if(BABYLON.Vector3.Distance(vecHoleSegmentStart, vecHoleSegmentEnd) < EPSILON ||
							meshInfoObj.doesSegmentIntersectFaces(vecHoleSegmentStart, vecHoleSegmentEnd, excludedSet))
							bIsHoleJump = false;
					}		

					if(!bIsHoleJump)
						continue;
				
					// We might have hit either face at the corner
					let hitFaceAdjacentInfo = meshFace;
					if(nextHitFaceAdjacentInfo)
					{
						let fNextDot = BABYLON.Vector3.Dot(nextHitFaceAdjacentInfo.normal, currNormal);
						let fCurrDot = BABYLON.Vector3.Dot(meshFace.normal, currNormal);

						if(Math.abs(fNextDot) > Math.abs(fCurrDot))
							hitFaceAdjacentInfo = nextHitFaceAdjacentInfo;
					}
					
					resInfo = this.buildNextPolygonInfo(testRay, inputValues, traversedFacesSet, meshInfoObj, currFaceInfo, fXStep, vecOrigUpAxis, fBreakAngle, hitFaceAdjacentInfo, fIntersectDist, true);
					if(resInfo)
						break;
				}
			
				if(resInfo)
					break;
			}
		}

		if(!resInfo && selfAdjacentFaceInfo)
			resInfo = this.buildNextPolygonInfo(testRay, inputValues, finalTraversedSet, meshInfoObj, currFaceInfo, fXStep, vecOrigUpAxis, fBreakAngle, selfAdjacentFaceInfo, fSelfIntersectDist);

		return resInfo;
	}

	createDebugFaceMarkings(meshInfo, scene)
	{
		if(!this.getParent().getFinalOutputNode() || this.getParent().getFinalOutputNode().getId() != this.getId())
			return;

		let faceInfos = meshInfo.getFaceInfos();
		for(let meshFace of faceInfos)
		{
			let pBox = BABYLON.MeshBuilder.CreateBox(this.getGeneratedMeshName(), { 
				width: 0.015, 
				depth: 0.015, 
				height: 0.015, 
				sideOrientation: BABYLON.Mesh.FRONTSIDE,
				updatable: false
			}, scene);

			pBox.name = `_face${meshFace.index}`;
			let vecTemp = meshFace.globalVerts[0].add(meshFace.globalVerts[1]).add(meshFace.globalVerts[2]);
			pBox.position = vecTemp.scale(1/3);
			pBox.material = new BABYLON.StandardMaterial(pBox.name, scene);
			pBox.material.diffuseColor = new BABYLON.Color3(1, 0, 0);
			pBox.material.emissiveColor = pBox.material.diffuseColor.scale(0.5);
		}
	}

	findConnectedEdge(rawEdges, edgeInfo, vecPoint)
	{
		for(let currEdgeInfo of rawEdges)
		{
			if(currEdgeInfo.isUsed)
				continue;

			if(currEdgeInfo.id === edgeInfo.id)
				continue;
			
			if(BABYLON.Vector3.Distance(vecPoint, currEdgeInfo.points[0]) < EPSILON)
				return { info: currEdgeInfo, pointIndex: 0 };
			if(BABYLON.Vector3.Distance(vecPoint, currEdgeInfo.points[currEdgeInfo.points.length - 1]) < EPSILON)
				return { info: currEdgeInfo, pointIndex: currEdgeInfo.points.length - 1 };
		}

		return null;
	}
	
	getConnectedEdges(wholeMeshInfo, fDegCreaseAngle, vecTargetUpAxis)
	{
		let fCreaseAngleCos = Math.cos(fDegCreaseAngle/180.0*Math.PI);

		let rawEdges = [];

		let currId = 0;
		let traversedFacesSet = new Set();

		let allMeshInfos = wholeMeshInfo.getFaceInfos();
		for(let meshFace of allMeshInfos)
		{
			// Check that the face is not facing away from the main vector:
			if(BABYLON.Vector3.Dot(vecTargetUpAxis, meshFace.normal) < 0.0)
				continue;

			for(let subIndex = 0; subIndex < 3; subIndex++)
			{
				let adjFaceInfo = wholeMeshInfo.getAdjacentFace(meshFace, subIndex, traversedFacesSet);
				if(!adjFaceInfo)
					continue;

				if(BABYLON.Vector3.Dot(vecTargetUpAxis, adjFaceInfo.normal) < 0.0)
					continue;

				// Check for the angle
				if(BABYLON.Vector3.Dot(adjFaceInfo.normal, meshFace.normal) >= fCreaseAngleCos)
					continue;

				// Otherwise, we have an edge!
				rawEdges.push({
					points: [meshFace.globalVerts[subIndex], meshFace.globalVerts[(subIndex + 1) % 3]],
					id: currId,
				});
				currId++;
			}
			traversedFacesSet.add(meshFace.index);
		}

		// Optionally weld verts?

		// Now, try to connect them into longer chains:
		let connectedEdgeInfo;
		let bHadConnectedEdges;
		for(let edgeInfo of rawEdges)
		{
			if(edgeInfo.isUsed)
				continue;
			
			do
			{
				bHadConnectedEdges = false;
				
				connectedEdgeInfo = this.findConnectedEdge(rawEdges, edgeInfo, edgeInfo.points[0]);
				if(connectedEdgeInfo)
				{
					connectedEdgeInfo.info.isUsed = true;
					bHadConnectedEdges = true;

					// Prepend it:
					edgeInfo.points.shift();
					if(connectedEdgeInfo.pointIndex === 0)
						connectedEdgeInfo.info.points.reverse();
					edgeInfo.points = [...connectedEdgeInfo.info.points, ...edgeInfo.points];
				}
				
				connectedEdgeInfo = this.findConnectedEdge(rawEdges, edgeInfo, edgeInfo.points[edgeInfo.points.length - 1]);
				if(connectedEdgeInfo)
				{
					connectedEdgeInfo.info.isUsed = true;
					bHadConnectedEdges = true;

					// Append it
					edgeInfo.points.pop();
					if(connectedEdgeInfo.pointIndex > 0)
						connectedEdgeInfo.info.points.reverse();
					edgeInfo.points = [...edgeInfo.points, ...connectedEdgeInfo.info.points];
				}
				
			}
			while(bHadConnectedEdges);
		}
		
		let finalEdges = [];
		for(let edgeInfo of rawEdges)
		{
			if(edgeInfo.isUsed)
				continue;

			let pSpline = new Spline(edgeInfo.points);
			pSpline.removeCollinearPoints();

			finalEdges.push(pSpline);
		}

		return finalEdges;
	}

	normalizeProbabilityArrayParameter(strProbArray, iNumObjects)
	{
		let rawProbabilitiesArray = CoreUtils.replaceAll(strProbArray, ' ', '').split(',');
		let probabilitiesArray = [];
		for(let probValue of rawProbabilitiesArray)
		{
			let fValue = parseFloat(probValue);
			if(!isNaN(fValue))
				probabilitiesArray.push({'p': fValue});
		}

		for(; probabilitiesArray.length > iNumObjects; )
			probabilitiesArray.pop();
		CoreUtils.normalizeProbabilityList(probabilitiesArray, 'p');
		for(; probabilitiesArray.length < iNumObjects; )
			probabilitiesArray.push({'p': 1.0/iNumObjects});
		CoreUtils.normalizeProbabilityList(probabilitiesArray, 'p');

		return probabilitiesArray;
	}

	createSurfacePointsFor(currFaceInfo, vecPosition, currSrcMesh, pSurfaceObjectsToDistribute, inputValues, pointMeshArray, pointVoxelGrid,
							vecBBoxCenter, vecBBoxSize, meshInfo, randomGenerator, fPerMeshOffsetY)
	{
		let faceVoxelGrid = meshInfo.getFaceVoxelGrid();

		// Threshold within which two polygons are considered planar when looking 
		// for duplicates.
		const fCreaseAngleForCoplanarDuplicateDetection = 20;
		const fDuplicateCoplanarCos = Math.cos(fCreaseAngleForCoplanarDuplicateDetection/180.0*Math.PI);

		let vecTarget = BABYLON.Vector3.Zero();

		let vecCenterShift = BABYLON.Vector3.Zero();
		let vecCurrJitter = BABYLON.Vector3.Zero();

		let vecFaceDownDir = BABYLON.Vector3.Cross(currFaceInfo.sideDir, currFaceInfo.normal);
		let vecSideFaceDir = BABYLON.Vector3.Zero();

		let meshesToCopy = pSurfaceObjectsToDistribute;
		if(inputValues['randomly_pick_tile_object'])
			meshesToCopy = [currSrcMesh];

		// Take care of any jitter we may have:
		vecCurrJitter.set(0, 0, 0);
		if(inputValues['jitter_hor'] && Math.abs(inputValues['jitter_hor_amount']) > EPSILON)
			vecCurrJitter.x = (randomGenerator() - 0.5)/0.5*inputValues['jitter_hor_amount'];
		if(inputValues['jitter_vert'] && Math.abs(inputValues['jitter_vert_amount']) > EPSILON)
			vecCurrJitter.y = (randomGenerator() - 0.5)/0.5*inputValues['jitter_vert_amount'];
		if(inputValues['jitter_perp'] && Math.abs(inputValues['jitter_perp_amount']) > EPSILON)
			vecCurrJitter.z = (randomGenerator() - 0.5)/0.5*inputValues['jitter_perp_amount'];

		const validDirection = new BABYLON.Vector3(inputValues['normal_x'], inputValues['normal_y'], inputValues['normal_z']);
		validDirection.normalize();
		const validAngleRange = inputValues['normal_range_angle'];
		const cosValidAngle = Math.cos(validAngleRange/180.0*Math.PI);

		for(let pMeshToCopy of meshesToCopy)
		{
			let oldPosition = pMeshToCopy.position.clone();
			let oldRotation = pMeshToCopy.rotation.clone();

			// TODO: Rename
			let pFinalMesh = pMeshToCopy;

			// Find the source position relative to the bbox center:
			if(inputValues['randomly_pick_tile_object'])
				vecCenterShift.set(0, 0, 0);
			else
				oldPosition.subtractToRef(vecBBoxCenter, vecCenterShift);

			// First, we ignore the normal offset, and position this in the middle perpendicularly speaking:
			pFinalMesh.position = vecPosition.add(currFaceInfo.sideDir.scale(vecCenterShift.x + vecCurrJitter.x));
			pFinalMesh.position.addInPlace(vecFaceDownDir.scale(-vecCenterShift.z + vecCurrJitter.y));

			// Orient
			pFinalMesh.position.addToRef(currFaceInfo.normal, vecTarget);
			pFinalMesh.lookAt(vecTarget);
			pFinalMesh.rotation = pFinalMesh.rotation.add(oldRotation);

			pFinalMesh.rotation.x += Math.PI/2.0;

			// If the mesh intersects any of the faces boundaries with the angle tolerance, add it to pCuttingMapInOut
			pFinalMesh.computeWorldMatrix(true);

			let bbox = pFinalMesh.getBoundingInfo().boundingBox;
			let fPadding = Math.max(bbox.extendSizeWorld.x, bbox.extendSizeWorld.y, bbox.extendSizeWorld.z)*0.1; 
			let fRayBBoxPadding = fPadding;
			let fDuplicateTestPadding = fPadding*4;

			let iVertex;
			for(iVertex = 0; iVertex < 3; iVertex++)
			{
				currFaceInfo.globalVerts[(iVertex + 1) % 3].subtractToRef(currFaceInfo.globalVerts[iVertex], vecSideFaceDir);
				const fLen = vecSideFaceDir.length();
				vecSideFaceDir.normalize();

				let pRay = new BABYLON.Ray(currFaceInfo.globalVerts[iVertex], vecSideFaceDir, fLen);
				if(pRay.intersectsBoxMinMax(bbox.minimumWorld, bbox.maximumWorld, EPSILON))
					break;
			}
			const bIntersectsAnyFace = (iVertex < 3);
if(pointMeshArray.length === 745)
{
	let bp = 0;
}
			let bIntersectsNonFlatFace = false;
			let candidateFaceInfos = faceVoxelGrid.getObjectsForSegment(bbox.minimumWorld, bbox.maximumWorld);
			for(let faceInfo of candidateFaceInfos)
			{
				let fDotProd = Math.abs(BABYLON.Vector3.Dot(faceInfo.normal, currFaceInfo.normal));
				if(fDotProd > fCreaseAngleCos)
					continue;

				for(iVertex = 0; iVertex < 3; iVertex++)
				{
					faceInfo.globalVerts[(iVertex + 1) % 3].subtractToRef(faceInfo.globalVerts[iVertex], vecSideFaceDir);
					const fLen = vecSideFaceDir.length();
					vecSideFaceDir.normalize();

					let pRay = new BABYLON.Ray(faceInfo.globalVerts[iVertex], vecSideFaceDir, fLen);
					if(pRay.intersectsBoxMinMax(bbox.minimumWorld, bbox.maximumWorld, fRayBBoxPadding))
					{
						bIntersectsNonFlatFace = true;
						break;
					}
				}

				if(bIntersectsNonFlatFace)
					break;
			}

			let bAddMesh = true;
			// If we don't intersect the face, we're either completely inside or completely outside. See if that's the case:
			if(!bIntersectsAnyFace && !Utils3D.isPointInTriangle(bbox.maximumWorld.add(bbox.minimumWorld).scale(0.5), currFaceInfo.globalVerts, true))
				bAddMesh = false;

			// Add the offset
			pFinalMesh.position.addInPlace(currFaceInfo.normal.scale(vecBBoxSize.y/2.0 + inputValues['perp_offset'] + vecCenterShift.y + vecCurrJitter.z - fPerMeshOffsetY));

			// Compute position projected onto the plane:
			let vecToOrigin = pFinalMesh.position.subtract(currFaceInfo.globalVerts[0]);
			let fPerpDist = BABYLON.Vector3.Dot(vecToOrigin, currFaceInfo.normal);
			let vecProjectedPos = pFinalMesh.position.subtract(currFaceInfo.normal.scale(fPerpDist));

			// See if there's a duplicate (for now, this might be slow):
			let infosToTest = pointVoxelGrid.getObjectsNear(vecProjectedPos, fDuplicateTestPadding*2);
			for(let pointInfo of infosToTest)
			{
				if(BABYLON.Vector3.Distance(pointInfo.projectedPos, vecProjectedPos) < fDuplicateTestPadding
					&& Math.abs(BABYLON.Vector3.Dot(pointInfo.faceNormal, currFaceInfo.normal)) > fDuplicateCoplanarCos)
					bAddMesh = false;
			}

			if(inputValues['simple_surface_mode'])
			{
				const dotProd = BABYLON.Vector3.Dot(currFaceInfo.normal, validDirection);
				if(dotProd < cosValidAngle)
					bAddMesh = false;
			}

			if(bAddMesh)
			{
				let positionInfo = {
					position: pFinalMesh.position.clone(),
					rotation: pFinalMesh.rotation.clone(),
					projectedPos: vecProjectedPos,
					srcMesh: pMeshToCopy,
					faceNormal: currFaceInfo.normal,
					cutFace: bIntersectsNonFlatFace ? currFaceInfo.faceIndex : null,
					faceIndex: currFaceInfo.faceIndex,
				};

				pointMeshArray.push(positionInfo);
				pointVoxelGrid.addObject(pFinalMesh.position, positionInfo);
			}

			pMeshToCopy.position = oldPosition.clone();
			pMeshToCopy.rotation = oldRotation.clone();
		}
	}
	/*
	computeVertexNormal(vecPoint, meshInfo, vecNormalOut)
	{
		let iNumFacesCounted = 0;
		vecNormalOut.set(0, 0, 0);
		let iVertex;
		for(let currInfo of meshInfo)
		{
			for(iVertex = 0; iVertex < 3; iVertex++)
			{
				if(BABYLON.Vector3.Distance(vecPoint, currInfo.globalVerts[iVertex]) < EPSILON)
					break;
			}	
			
			if(iVertex >= 3)
				continue;
			// Otherwise, add the face normal to the cumulative vertex:
			vecNormalOut.addInPlace(currInfo.normal);
			iNumFacesCounted++;
		}
		if(iNumFacesCounted > 0)
			vecNormalOut.scaleInPlace(1.0/iNumFacesCounted);
		vecNormalOut.normalize();
	}
	*/

	buildCutoutMesh(currInfo, meshInfo, scene)
	{
		const indices = [
			// Back face
			2, 1, 0,
			
			// Front face
			3, 4, 5,
			3, 5, 6,
			3, 6, 7,
			3, 7, 8,

			// Triangles to the vertex spreads
			2, 7, 6,
			0, 3, 8,
			1, 5, 4,

			// Sides
			2, 6, 1,
			6, 5, 1,

			2, 0, 8,
			8, 7, 2,

			4, 3, 0,
			0, 1, 4,
		];

		const BOOLEAN_DEPTH_FORWARD = 0.5;
		const BOOLEAN_DEPTH_BACK = 0.001;

		const fFaceExpandAmount = 1e-3;

		// TODO: Cache these outside, build a generic cacher that can live through multiple node cooks and works with types + labels
		let expandedVerts = [BABYLON.Vector3.Zero(), BABYLON.Vector3.Zero(), BABYLON.Vector3.Zero()];
		let farSidePositions = [BABYLON.Vector3.Zero(), BABYLON.Vector3.Zero(), BABYLON.Vector3.Zero(), BABYLON.Vector3.Zero(), BABYLON.Vector3.Zero(), BABYLON.Vector3.Zero()];
		let nearSidePositions = [BABYLON.Vector3.Zero(), BABYLON.Vector3.Zero(), BABYLON.Vector3.Zero()];
		let edgeNormal = BABYLON.Vector3.Zero();
		let faceCenter = BABYLON.Vector3.Zero();

		faceCenter.set(0, 0, 0);
		for(let iVertex = 0; iVertex < 3; iVertex++)
			faceCenter.addInPlace(currInfo.globalVerts[iVertex]);
		faceCenter.scaleInPlace(1/3);

		for(let iVertex = 0; iVertex < 3; iVertex++)
		{
			let vecToCenter = currInfo.globalVerts[iVertex].subtract(faceCenter);
			let fLen = vecToCenter.length();
			vecToCenter.normalize();
			faceCenter.addToRef(vecToCenter.scale(fLen + fFaceExpandAmount), expandedVerts[iVertex]);
		}

		// Otherwise, we have a list of meshes to cut

		// Create the plane for this face:
		let fPlaneDist = BABYLON.Vector3.Dot(faceCenter.add(currInfo.normal.scale(BOOLEAN_DEPTH_FORWARD)), currInfo.normal);
		let pTargetPlane = new BABYLON.Plane(currInfo.normal.x, currInfo.normal.y, currInfo.normal.z, -fPlaneDist);
		let pTestRay = new BABYLON.Ray();

		// Create an extruded and mitered shape for the face.
		// We need to compute per vertex normals:
		for(let iVertex = 0; iVertex < 3; iVertex++)
		{
if(currInfo.index == 27)
{
	let bp = 0;
}

			const iNextIndex = (iVertex + 1) % 3;
			//let adjacentFace = meshInfo.getAdjacentFace(currInfo.globalVerts[iVertex], currInfo.globalVerts[iNextIndex], currInfo.index, null, ADJACENT_FACE_EPSILON);
			let adjacentFace = meshInfo.getAdjacentFace(currInfo, iVertex);
			edgeNormal.copyFrom(currInfo.normal);
			if(adjacentFace)
			{
				edgeNormal.addInPlace(adjacentFace.normal);
				edgeNormal.scaleInPlace(0.5);					
			}
			else
				edgeNormal.addInPlaceFromFloats(0, -0.01, 0);
			edgeNormal.normalize();

			pTestRay.direction = edgeNormal;

			pTestRay.origin = expandedVerts[iVertex];
			fPlaneDist = pTestRay.intersectsPlane(pTargetPlane);
			expandedVerts[iVertex].addToRef(edgeNormal.scale(fPlaneDist), farSidePositions[iVertex*2]);

			pTestRay.origin = expandedVerts[iNextIndex];
			fPlaneDist = pTestRay.intersectsPlane(pTargetPlane);
			expandedVerts[iNextIndex].addToRef(edgeNormal.scale(fPlaneDist), farSidePositions[iVertex*2 + 1]);

			expandedVerts[iVertex].addToRef(currInfo.normal.scale(-BOOLEAN_DEPTH_BACK), nearSidePositions[iVertex]);
		}

if(currInfo.index == 189)
{
	let bp = 0;
}

		const VERTEX_MOVE_APART_DISTANCE = EPSILON*40;

		// Take care of ensuring no points fully coincide, since this will cause stack overflow errors when building the CSG
		for(let idx = 0; idx < farSidePositions.length; idx++)
		{
			let iNextIdx = (idx + 1) % farSidePositions.length;
			if(BABYLON.Vector3.Distance(farSidePositions[idx], farSidePositions[iNextIdx]) > EPSILON)
				continue;

			// Otherwise, we need to move them apart a bit:
			let iNextNextIdx = (idx + 2) % farSidePositions.length;
			let vecDir = farSidePositions[iNextNextIdx].subtract(farSidePositions[iNextIdx]);

			if(vecDir.length() < EPSILON)
			{
				let iPrevIdx = idx - 1;
				if(iPrevIdx < 0)
					iPrevIdx += farSidePositions.length;
				let vecDir = farSidePositions[iPrevIdx].subtract(farSidePositions[idx]);
				vecDir.normalize();

				if(vecDir.length() < EPSILON)
				{
					vecDir = currInfo.normal;
					console.warn(`Zero-length direction detected for face ${currInfo.index}, boolean might fail`);
				}

				farSidePositions[idx] = farSidePositions[idx].add(vecDir.scale(-VERTEX_MOVE_APART_DISTANCE));
			}
			else
				farSidePositions[iNextIdx] = farSidePositions[iNextIdx].add(vecDir.scale(VERTEX_MOVE_APART_DISTANCE));
		}


		// Take care of any possible self-intersections
		for(let idx = 0; idx < 6; idx += 2)
		{
			let nextIdx = idx + 1;

			let iOtherSegStartIdx = (idx + 2) % farSidePositions.length;
			let iOtherSegEndIdx = (idx + 3) % farSidePositions.length;

			let vecDir = farSidePositions[nextIdx].subtract(farSidePositions[idx]);
			let fSegmentLen = vecDir.length();
			vecDir.normalize();
			let currIntersectRes = Utils3D.rayLineIntersection(farSidePositions[idx], vecDir, farSidePositions[iOtherSegStartIdx], farSidePositions[iOtherSegEndIdx]);

			if(currIntersectRes.dIntersect < fSegmentLen - EPSILON && currIntersectRes.dIntersect > EPSILON)
			{
				let vecIntersect = farSidePositions[idx].add(vecDir.scale(currIntersectRes.dIntersect));
				farSidePositions[nextIdx] = vecIntersect.subtract(vecDir.scale(VERTEX_MOVE_APART_DISTANCE));

				farSidePositions[iOtherSegStartIdx] = vecIntersect.add(currIntersectRes.otherDir.scale(VERTEX_MOVE_APART_DISTANCE));
			}

		}

		let positions = [];
		nearSidePositions.forEach((vecPoint) => { 
			positions.push(vecPoint.x); 
			positions.push(vecPoint.y);
			positions.push(vecPoint.z);
		});
		farSidePositions.forEach((vecPoint) => { 
			positions.push(vecPoint.x); 
			positions.push(vecPoint.y);
			positions.push(vecPoint.z);
		});

		// Build the actual mesh
		let cutoutMesh = new BABYLON.Mesh(`_subtractMesh_${currInfo.index}`, scene);

		let vertexData = new BABYLON.VertexData();
		vertexData.positions = positions;
		vertexData.indices = indices.slice(0);	
		vertexData.applyToMesh(cutoutMesh);

		cutoutMesh.createNormals();
		GeoUtils.applyBoxUVsToMeshes([cutoutMesh]);

		cutoutMesh.convertToFlatShadedMesh();

		if(DEBUG_VERBOSE_OUTPUT)
			CoreUtils.log(`Built cutout mesh for face ${currInfo.index}`);

		return cutoutMesh;
	}

	cutEdgeMeshes(scene, meshInfoObj, cuttingMap, pResMeshesListIn)
	{
		let meshesToDelete = {};
		let substituteMeshMap = {};

		// Build a mesh map for faster access:
		let resMeshMap = new Map();
		pResMeshesListIn.forEach((pMesh) => { resMeshMap.set(pMesh.uniqueId, pMesh); });

		// Pre-build cut meshes, since we may reference some multiple times from multiple other faces.
		let builtCutoutMeshes = {};
		let builtCSGs = {};

		let meshInfo = meshInfoObj.getFaceInfos();
		for(let currInfo of meshInfo)
		{
			if(!cuttingMap[currInfo.index])
				continue;
			
			if(!builtCutoutMeshes[currInfo.index])
				builtCutoutMeshes[currInfo.index] = this.buildCutoutMesh(currInfo, meshInfoObj, scene);

			let cutoutCSG = null;
			if(!DEBUG_SKIP_BUILDING_CSG)
			{
				if(DEBUG_VERBOSE_OUTPUT)
					CoreUtils.log(`Build main CSG start for ${currInfo.index}`);
				cutoutCSG = CSG_LIB.CSG.FromMesh(builtCutoutMeshes[currInfo.index]);
				if(DEBUG_VERBOSE_OUTPUT)
					CoreUtils.log(`Build main CSG end`);
			}

			// Build a bbox for all of them:
			let overallBBox = { minimumWorld: new BABYLON.Vector3(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE), maximumWorld: new BABYLON.Vector3(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE) };
			for(let pIntersectMesh of cuttingMap[currInfo.index].meshes)
			{
				pIntersectMesh.computeWorldMatrix();
				let pBBox = pIntersectMesh.getBoundingInfo().boundingBox;
				Utils3D.includeBBox(overallBBox, pBBox);
			}

			// Now, add any others from flat adjacent faces that intersect any of our meshes.
			// TODO: Remove okl flat adj faces array
			let adjacentFaces = meshInfoObj.getIntersectedFaces(overallBBox.minimumWorld, overallBBox.maximumWorld, currInfo.index);
			for(let adjacentFaceInfo of adjacentFaces)
			{
				let fDotProd = Math.abs(BABYLON.Vector3.Dot(adjacentFaceInfo.normal, currInfo.normal));
				if(fDotProd < fCreaseAngleCos)
					continue;

				const key = adjacentFaceInfo.index;
				if(!builtCutoutMeshes[key])
					builtCutoutMeshes[key] = this.buildCutoutMesh(adjacentFaceInfo, meshInfoObj, scene);

				if(!DEBUG_SKIP_BUILDING_CSG)
				{
					if(DEBUG_VERBOSE_OUTPUT)
						CoreUtils.log(`Build secondary CSG start for ${key}`);

					//if(!builtCSGs[key])
					//	builtCSGs[key] = CSG_LIB.CSG.FromMesh(builtCutoutMeshes[key]);
					//let additionalCSG = builtCSGs[key];
					let additionalCSG = CSG_LIB.CSG.FromMesh(builtCutoutMeshes[key]);

					if(DEBUG_VERBOSE_OUTPUT)
						CoreUtils.log(`Build secondary CSG end, begin union for ${key}`);
					cutoutCSG.unionInPlace(additionalCSG);
					if(DEBUG_VERBOSE_OUTPUT)
						CoreUtils.log(`Secondary CSG union end for ${key}`);
				}
			}

			// Cut per mesh, intersect with that shape
			//if(false)
			if(!DEBUG_SKIP_BUILDING_CSG)
			for(let pIntersectMesh of cuttingMap[currInfo.index].meshes)
			{
if(pIntersectMesh.name === 'distributeOnSurface17_s30')
{
	let bp = 0;
}
				if(substituteMeshMap[pIntersectMesh.uniqueId])
					pIntersectMesh = substituteMeshMap[pIntersectMesh.uniqueId];
if(pIntersectMesh.name === 'distributeOnSurface17_s30')
{
	let bp = 0;
}
				let currCSG = CSG_LIB.CSG.FromMesh(pIntersectMesh);
				currCSG.intersectInPlace(cutoutCSG);

				// Replace the old mesh in the pResMeshesListInOut with the new one,
				// or better yet, do the boolean into the existing mesh
				let currMesh = resMeshMap.get(pIntersectMesh.uniqueId);
				if(currMesh)
				{
					// Found it, do the cut:
					let pNewMesh = currCSG.toMesh(currMesh.name, currMesh.material, scene);

					meshesToDelete[currMesh.uniqueId] = currMesh;
					
					// Take care of cases where the mesh is actually empty:
					if(pNewMesh.getIndices().length > 0)
					{
						substituteMeshMap[currMesh.uniqueId] = pNewMesh;
						
						// We need this because while cutting, the normals on flat meshes
						// get thrown off - not that they're incorrect, they're just rotated relative
						// to the normals on untouched meshes, creating a very noticeable difference in lighting.
						// The easiest solution for now is to force-recompute flat normals, but we may need a switch 
						// for it or to detect it automatically on a per-mesh basis.
						pNewMesh.convertToFlatShadedMesh();
						this.onMeshCreated(pNewMesh);

						resMeshMap.set(pNewMesh.uniqueId, pNewMesh);
					}
					else
					{
						meshesToDelete[pNewMesh.uniqueId] = pNewMesh;
						resMeshMap.delete(currMesh.uniqueId);
					}
				}
			}
		}
	
		let resMeshesArray = [];
		if(DEBUG_VISUALIZE_CUTTING_MESHES)
		{
			const SPECIFIC_FACE_ID = 189;
			for(let key in builtCutoutMeshes)
			{
				if(SPECIFIC_FACE_ID < 0 || SPECIFIC_FACE_ID == key)
				{
					this.onMeshCreated(builtCutoutMeshes[key]);
					resMeshesArray.push(builtCutoutMeshes[key]);
				}
				else
					builtCutoutMeshes[key].dispose();
			}
		}
		else
		{
			for(let key in builtCutoutMeshes)
				builtCutoutMeshes[key].dispose();
		}

		for(let key in meshesToDelete)
			meshesToDelete[key].dispose();

		resMeshMap.forEach((pMesh) => { resMeshesArray.push(pMesh); });
		return resMeshesArray;
	}

	sampleSurface(scene, pSurfaceObjectsToDistribute, allMeshInfosObj, meshInfoObj, inputValues, vecTargetUpAxis, randomGenerator, pTargetObjectsBBox)
	{
		let meshInfo = meshInfoObj.getFaceInfos();

		let pResMeshesList = [];

		let vecInOutAxis = BABYLON.Vector3.Zero();
		let vecOrigSideDir = BABYLON.Vector3.Zero();
		Utils3D.getCoordSystemFromNormal(vecTargetUpAxis, vecInOutAxis, vecOrigSideDir);

		let currSrcMesh = null;
		let probabilitiesArray;

		let pBBox = Utils3D.getObjectsBBoxWithChildren(pSurfaceObjectsToDistribute);
		let vecBBoxSize = pBBox.maximumWorld.subtract(pBBox.minimumWorld);
		let vecBBoxCenter = pBBox.maximumWorld.add(pBBox.minimumWorld).scale(0.5);

		let fXStep = vecBBoxSize.x + inputValues['hor_spacing'];
		let fYStep = vecBBoxSize.z + inputValues['vert_spacing'];
		let fPerMeshOffsetY = 0;

		let funcPickNextRandomObject = () => {
			let pickIndex = CoreUtils.pickFromProbabilityList(probabilitiesArray, 'p', false, randomGenerator());
			currSrcMesh = pSurfaceObjectsToDistribute[pickIndex];

			currSrcMesh.computeWorldMatrix();

			let currBBox = currSrcMesh.getBoundingInfo().boundingBox;
			let currSrcMeshSize = currBBox.maximumWorld.subtract(currBBox.minimumWorld);

			fXStep = currSrcMeshSize.x + inputValues['hor_spacing'];
			fYStep = currSrcMeshSize.z + inputValues['vert_spacing'];
			fPerMeshOffsetY = (vecBBoxSize.y - currSrcMeshSize.y)/2;
		};

		if(inputValues['randomly_pick_tile_object'])
		{
			probabilitiesArray = this.normalizeProbabilityArrayParameter(inputValues['probabilities'], pSurfaceObjectsToDistribute.length);
			funcPickNextRandomObject();
		}

		// Pick a start face
		let fMaxYPos = -Number.MAX_VALUE;
		let startInfo = new FaceTraversalInfo();
		let tempInfo = new FaceTraversalInfo();
		for(let currInfo of meshInfo)
		{
			const fCurrMaxY = Math.max(...currInfo.globalVerts.map((vecPoint) => { return BABYLON.Vector3.Dot(vecPoint, vecTargetUpAxis); }));

			if(fCurrMaxY < fMaxYPos)
				continue;

			// Ensure our actual start point is inside this face
			let bHaveStartPointInside = false;
			let testFacePosition;

			let vecFaceSideDir = Utils3D.computeNextDirectionAlongSurface(vecOrigSideDir, vecInOutAxis, currInfo.normal, vecTargetUpAxis);
			let vecFaceDownDir = BABYLON.Vector3.Cross(vecFaceSideDir, currInfo.normal);
			for(let vecPoint of currInfo.globalVerts)
			{
				if(BABYLON.Vector3.Dot(vecPoint, vecTargetUpAxis) < fCurrMaxY)
					continue;

				testFacePosition = vecPoint.add(vecFaceDownDir.scale(fYStep/2)).add(vecFaceSideDir.scale(fXStep/2));
				if(Utils3D.isPointInTriangle(testFacePosition, currInfo.globalVerts))
				{
					bHaveStartPointInside = true;
					break;
				}
			}

			if(bHaveStartPointInside)
			{
				fMaxYPos = fCurrMaxY;					

				startInfo.sideDir = vecFaceSideDir;
				startInfo.facePosition = testFacePosition;
				startInfo.faceIndex = currInfo.index;
				startInfo.normal = currInfo.normal.clone();
				startInfo.globalVerts = currInfo.globalVerts;
				startInfo.adjacentFaces = currInfo.adjacentFaces;
			}
			else
			{
				// We can be in situations where something like a sphere is built such that no face at the top will
				// have the test point inside - it will always fall onto the next face, and so we'll end up picking much
				// lower than we should be.
				// So try to get the next poly as if we were advacing.

				let vecPoint = currInfo.globalVerts.filter((vecPoint) => { return BABYLON.Vector3.Dot(vecPoint, vecTargetUpAxis) >= fCurrMaxY; })[0];
				tempInfo.facePosition = vecPoint.add(vecFaceDownDir.scale(fYStep/2));

				let faceInfoWithPoint = meshInfoObj.getMeshFaceClosestTo(tempInfo.facePosition);
				if(faceInfoWithPoint.info)
				{
					vecFaceSideDir = Utils3D.computeNextDirectionAlongSurface(vecOrigSideDir, vecInOutAxis, faceInfoWithPoint.info.normal, vecTargetUpAxis);

					tempInfo.facePosition = faceInfoWithPoint.projectedPoint;

					tempInfo.sideDir = vecFaceSideDir;
					tempInfo.faceIndex = faceInfoWithPoint.info.index;
					tempInfo.normal = faceInfoWithPoint.info.normal.clone();
					tempInfo.globalVerts = faceInfoWithPoint.info.globalVerts;
					tempInfo.adjacentFaces = faceInfoWithPoint.info.adjacentFaces;

					let excludeSet = new Set([tempInfo.index]);
					let nextFaceInfo = this.pickNextPolygon(inputValues, excludeSet, meshInfoObj, tempInfo, fXStep/2, vecTargetUpAxis);
					if(nextFaceInfo)
					{
						const fNextFaceMaxY = Math.max(...nextFaceInfo.globalVerts.map((vecPoint) => { return BABYLON.Vector3.Dot(vecPoint, vecTargetUpAxis); }));
						if(fNextFaceMaxY >= fMaxYPos)
						{
							fMaxYPos = fNextFaceMaxY;		
							startInfo = nextFaceInfo;
						}
					}
				}
			}
		}

		if(startInfo.faceIndex < 0)
			return pResMeshesList;

		if(DEBUG_VERBOSE_OUTPUT)
			CoreUtils.log(`Start info found`);

		// Now, attempt to step back along the face until the point is no longer in it:
		let vecPrevPos;
		let finalStartPos = startInfo.facePosition;
		do
		{
			vecPrevPos = finalStartPos;
			finalStartPos = finalStartPos.add(startInfo.sideDir.scale(-fXStep));
		}
		while(Utils3D.isPointInTriangle(finalStartPos, startInfo.globalVerts));
		startInfo.facePosition = vecPrevPos;

		let meshCreationInfos = [];

		let currFaceInfo = startInfo.clone();
		let rowStartInfo = startInfo.clone();
		let rowTraversedFaceIndices = new Set([currFaceInfo.faceIndex]);

		// Build the voxel grid, make it a bit larger than the object:
		let vecVoxelGridPadding = meshInfoObj.getSize().scale(0.25);
		let pointVoxelGrid = new VoxelGrid(pTargetObjectsBBox.minimumWorld.subtract(vecVoxelGridPadding), pTargetObjectsBBox.maximumWorld.add(vecVoxelGridPadding));

		// Step back and add one more tile
		let vecNewPos = startInfo.facePosition.subtract(startInfo.sideDir.scale(fXStep));
		this.createSurfacePointsFor(startInfo, vecNewPos, currSrcMesh, pSurfaceObjectsToDistribute, inputValues, meshCreationInfos, pointVoxelGrid, vecBBoxCenter, vecBBoxSize, meshInfoObj, randomGenerator, fPerMeshOffsetY);
		if(inputValues['randomly_pick_tile_object'])
			funcPickNextRandomObject();

		do
		{
			this.createSurfacePointsFor(currFaceInfo, currFaceInfo.facePosition, currSrcMesh, pSurfaceObjectsToDistribute, inputValues, meshCreationInfos, pointVoxelGrid, vecBBoxCenter, vecBBoxSize, meshInfoObj, randomGenerator, fPerMeshOffsetY);

			// Pick the next mesh to use, if applicable:
			if(inputValues['randomly_pick_tile_object'])
				funcPickNextRandomObject();

			// Find the next position. First, try naively incrementing it and see if we're still within the same face:
			let vecNewPos = currFaceInfo.facePosition.add(currFaceInfo.sideDir.scale(fXStep));
			if(Utils3D.isPointInTriangle(vecNewPos, currFaceInfo.globalVerts))
			{
				currFaceInfo.facePosition = vecNewPos;
				continue;
			}

			// Otherwise, we need to pick the next face to tile over

			// We need to make another copy to cover the rest of the space and pick the next mesh:
			this.createSurfacePointsFor(currFaceInfo, vecNewPos, currSrcMesh, pSurfaceObjectsToDistribute, inputValues, meshCreationInfos, pointVoxelGrid, vecBBoxCenter, vecBBoxSize, meshInfoObj, randomGenerator, fPerMeshOffsetY);
			if(inputValues['randomly_pick_tile_object'])
				funcPickNextRandomObject();

if(meshCreationInfos.length === 4088)
{
	let bp = 0;
}


			let fBreakAngle = 0;
			if(inputValues['start_from_each_face_boundary'])
				fBreakAngle = inputValues['face_boundary_crease_angle'];

			//CoreUtils.log(`Picking next face: num tiles = ${meshCreationInfos.length} curr face id = ${currFaceInfo.faceIndex}`);

			currFaceInfo = this.pickNextPolygon(inputValues, rowTraversedFaceIndices, meshInfoObj, currFaceInfo, fXStep, vecTargetUpAxis, fBreakAngle);

			if(!currFaceInfo)
			{
				// No next horizontal poly found, try going down a level:
				currFaceInfo = rowStartInfo.clone();
				rowTraversedFaceIndices = new Set([currFaceInfo.faceIndex]);

				let vecFaceDownDir = BABYLON.Vector3.Cross(rowStartInfo.sideDir, rowStartInfo.normal);

				let vecNewPos = currFaceInfo.facePosition.add(vecFaceDownDir.scale(fYStep));
				if(!Utils3D.isPointInTriangle(vecNewPos, currFaceInfo.globalVerts))
				{
					let prevSideDir = currFaceInfo.sideDir;
					currFaceInfo.sideDir = vecFaceDownDir;
//DEBUG_TRACE_PICKING = true;
					currFaceInfo = this.pickNextPolygon(inputValues, rowTraversedFaceIndices, meshInfoObj, currFaceInfo, fYStep, prevSideDir);
//DEBUG_TRACE_PICKING = false;
					if(currFaceInfo)
					{
						// The side dir might now be different if the faces are tilted (even a little bit)
						// relative to each other, so we can't use the starting one:
						currFaceInfo.sideDir = Utils3D.computeNextDirectionAlongSurface(rowStartInfo.sideDir, rowStartInfo.normal, currFaceInfo.normal, vecTargetUpAxis);
						rowTraversedFaceIndices = new Set([currFaceInfo.faceIndex]);
					}
				}
				else
					currFaceInfo.facePosition = vecNewPos;

				// Now, attempt to step back along the face until the point is no longer in it:
				if(currFaceInfo)
				{
					let vecPrevPos;
					let finalStartPos = currFaceInfo.facePosition;
					do
					{
						vecPrevPos = finalStartPos;
						finalStartPos = finalStartPos.add(currFaceInfo.sideDir.scale(-fXStep));
					}
					while(Utils3D.isPointInTriangle(finalStartPos, currFaceInfo.globalVerts));
					currFaceInfo.facePosition = vecPrevPos;

					rowStartInfo = currFaceInfo.clone();

					// Create a copy one step back (used for cutting later)
					let vecNewPos = rowStartInfo.facePosition.subtract(rowStartInfo.sideDir.scale(fXStep));
					this.createSurfacePointsFor(rowStartInfo, vecNewPos, currSrcMesh, pSurfaceObjectsToDistribute, inputValues, meshCreationInfos, pointVoxelGrid, vecBBoxCenter, vecBBoxSize, meshInfoObj, randomGenerator, fPerMeshOffsetY);
					if(inputValues['randomly_pick_tile_object'])
						funcPickNextRandomObject();
				}
			}
			else
			{
				// Create a copy one step back (used for cutting later)
				let vecNewPos = currFaceInfo.facePosition.subtract(currFaceInfo.sideDir.scale(fXStep));
				this.createSurfacePointsFor(currFaceInfo, vecNewPos, currSrcMesh, pSurfaceObjectsToDistribute, inputValues, meshCreationInfos, pointVoxelGrid, vecBBoxCenter, vecBBoxSize, meshInfoObj, randomGenerator, fPerMeshOffsetY);
				if(inputValues['randomly_pick_tile_object'])
					funcPickNextRandomObject();
			}

		}
		while(currFaceInfo && meshCreationInfos.length < MAX_TILES);

		let iNumInstancesCreated = 0;

		let dbMaterialsMap = {};
		// Now we need to actually create the meshes or their instances
		let iCounter = 0;
		let instanceMeshMap = {};
		let cuttingMap = {};
		for(let info of meshCreationInfos)
		{
			let bCreateInstance = !!(inputValues['use_instances'] && instanceMeshMap[info.srcMesh.uniqueId]);
			if(info.cutFace !== null)
				bCreateInstance = false;

			let trueSourceMesh = bCreateInstance ? instanceMeshMap[info.srcMesh.uniqueId] : info.srcMesh;
			let pFinalMesh = Utils3D.cloneMesh(trueSourceMesh, this.getGeneratedMeshName() + "_s" + iCounter, true, bCreateInstance);
			if(info.cutFace === null && inputValues['use_instances'] && !instanceMeshMap[info.srcMesh.uniqueId])
				instanceMeshMap[info.srcMesh.uniqueId] = pFinalMesh;
			this.onMeshCreated(pFinalMesh);
			iCounter++;

			if(bCreateInstance)
				iNumInstancesCreated++;

			pFinalMesh.position = info.position;
			pFinalMesh.rotation = info.rotation;

			if(DEBUG_VISUALIZE_PER_FACE_COLORS)
			{
				if(!dbMaterialsMap[info.faceIndex])
				{
					let pNewMaterial = new BABYLON.StandardMaterial(pFinalMesh.name, scene);
					pNewMaterial.diffuseColor = BABYLON.Color3.Random();
					pNewMaterial.emissiveColor = pNewMaterial.diffuseColor.scale(0.5);

					dbMaterialsMap[info.faceIndex] = pNewMaterial;
				}
				pFinalMesh.material = dbMaterialsMap[info.faceIndex];
			}

			pResMeshesList.push(pFinalMesh);

			if(info.cutFace !== null)
			{
				if(!cuttingMap[info.cutFace])
					cuttingMap[info.cutFace] = { meshes: [] };
				cuttingMap[info.cutFace].meshes.push(pFinalMesh);
			}
		}

		if(meshCreationInfos.length > 0 && inputValues['use_instances'])
			CoreUtils.log(`Created ${iNumInstancesCreated} instances out ${meshCreationInfos.length} objects (${(iNumInstancesCreated/meshCreationInfos.length*100).toFixed(0)}%)`);

		// Cut meshes
		if(inputValues['enable_edge_cutting'] && !DEBUG_DISABLE_TILE_CUTTING)
			pResMeshesList = this.cutEdgeMeshes(scene, allMeshInfosObj, cuttingMap, pResMeshesList);

		return pResMeshesList;
	}

	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{
		let pSurfaceObjectsToDistribute = inputValues['object'];
		let pEdgeObjectsToDistribute = inputValues['edge_object'];
		let pTargetObjects = inputValues['target'];

		if(!pTargetObjects || !Array.isArray(pTargetObjects))
			return null;

		const bHaveValidSurfaceObjects = pSurfaceObjectsToDistribute && Array.isArray(pSurfaceObjectsToDistribute);
		if(bHaveValidSurfaceObjects)
		{
			pSurfaceObjectsToDistribute = pSurfaceObjectsToDistribute.filter((obj) => { return Utils.getIsMeshObject(obj); });
			if(pSurfaceObjectsToDistribute.length === 0)
				bHaveValidSurfaceObjects = false;
		}

		const bHaveValidEdgeObjects = pEdgeObjectsToDistribute && Array.isArray(pEdgeObjectsToDistribute);
		if(bHaveValidEdgeObjects)
		{
			pEdgeObjectsToDistribute = pEdgeObjectsToDistribute.filter((obj) => { return Utils.getIsMeshObject(obj); });
			if(pEdgeObjectsToDistribute.length === 0)
				bHaveValidEdgeObjects = false;
		}

		// Find the first polygon that is not coincident with our normal
		if(pTargetObjects.length < 1)
			return null;

		let vecTargetUpAxis = new BABYLON.Vector3(0, 1, 0);
		if(inputValues['simple_surface_mode'])
		{
			let vecInOutAxis = BABYLON.Vector3.Zero();
			let vecOrigSideDir = BABYLON.Vector3.Zero();
			Utils3D.getCoordSystemFromNormal(vecTargetUpAxis, vecInOutAxis, vecOrigSideDir);
			vecTargetUpAxis = vecInOutAxis;
		}
		
		let pTargetObjectsBBox = Utils3D.getObjectsBBoxWithChildren(pTargetObjects);

		// Sometimes we get bad geometry from booleans which throws things off. Make sure we fix it.
		let iNumSplits = 0;
		let iNumFailed = 0;
		pTargetObjects.forEach((mesh) => { 
			let splitInfo = GeoUtils.splitOverlappingMeshEdges(mesh); 
			iNumSplits += splitInfo.numSplits;
			iNumFailed += splitInfo.numFailed;
		});
		if(DEBUG_VERBOSE_OUTPUT)
			CoreUtils.log(`Pass 1: Split ${iNumSplits} overlapping edges, failed on ${iNumFailed} edges`);

		let randomGenerator = seedrandom(inputValues['random_seed']);
		let resMeshes = [];

		for(let pSrcMesh of pTargetObjects)
		{
			if(!pSrcMesh)
				continue;

			let wholeMeshInfo = new MeshInfo(pSrcMesh);
			let meshInfo = MeshInfo.createFromOtherInfo(wholeMeshInfo, (currInfo) => {
				const bIsFacingUp = Math.abs(Math.abs(BABYLON.Vector3.Dot(currInfo.normal, vecTargetUpAxis)) - 1.0) < EPSILON;
				return !bIsFacingUp;
			});

			meshInfo.computeFaceVoxelGrid(0.25);

			wholeMeshInfo.computeAdjacentFaces(ADJACENT_FACE_EPSILON);
			meshInfo.computeAdjacentFaces(ADJACENT_FACE_EPSILON);

			if(DEBUG_CREATE_FACE_MARKERS)
				this.createDebugFaceMarkings(meshInfo, scene);

			// Sample surface
			if(inputValues['sample_surface'] && bHaveValidSurfaceObjects)
			{
				let currMeshes = this.sampleSurface(scene, pSurfaceObjectsToDistribute, wholeMeshInfo, meshInfo, inputValues, vecTargetUpAxis, randomGenerator, pTargetObjectsBBox);
				resMeshes = resMeshes.concat(currMeshes);
			}
		}

		// Now, see if we have to distribute over edges, too:
		if(inputValues['sample_edges'] && bHaveValidEdgeObjects)
		{
			let iCounter = 0;
			let connectedEdges = this.getConnectedEdges(wholeMeshInfo, inputValues['edge_crease_angle'], vecTargetUpAxis);

			let pEdgeMesh = pEdgeObjectsToDistribute[0];

			let pBBox = Utils3D.getObjectsBBoxWithChildren([pEdgeMesh]);
			let vecBBoxSize = pBBox.maximumWorld.subtract(pBBox.minimumWorld);
			let vecBBoxCenter = pBBox.maximumWorld.add(pBBox.minimumWorld).scale(0.5);

			let fXStep = vecBBoxSize.x + inputValues['hor_spacing'];
			let fYStep = vecBBoxSize.z + inputValues['vert_spacing'];

			for(let pSpline of connectedEdges)
			{
				// TODO: Fix
				GeoUtils.copyObjectsAlongSpline(pEdgeMesh, pSpline, {
					copy_type: 'resample',
					resample_type: 'byDistance',
					spacing: fYStep,
					use_instances: () => {
						return inputValues['use_instances'];
					},
					orient_with_path: true
				},
				(pMesh, bIsInstance) => {

					if(!bIsInstance)
					{
						let oldRotation = pMesh.rotation.clone();
						pMesh.rotation.set(0, 0, 0);

						GeoUtils.bendSingleMesh(pMesh, 45.0, 90.0, 'zaxis');

						pMesh.rotation = oldRotation;
					}

					pMesh.name = `${this.getGeneratedMeshName()}_e${iCounter}`;
					iCounter++;
					this.onMeshCreated(pMesh);
					resMeshes.push(pMesh);			
				});
			}
		}

		if(bHaveValidSurfaceObjects)
		{
			for(let pMesh of pSurfaceObjectsToDistribute)
				pMesh.dispose();
		}

		if(bHaveValidEdgeObjects)
		{
			for(let pMesh of pEdgeObjectsToDistribute)
				pMesh.dispose();
		}

		return resMeshes;
	}
}